import Finalize from "pages/Finalize/Finalize";
import { FC } from "react";

export const SSOFinalize: FC = () => (
    <Finalize type="sso-finalize" />
)
